export default {
	'please-select-a-role': 'Please select a role',
	'loading-roles': 'Loading roles...',
}